/**
 * Main File For All Feed Related Services
 *
 * @author Creator-Solutions -> Owen Burns
 */

import axios, { AxiosResponse } from "axios";

import {
  FeedResponseState,
  GetFeedInterface,
} from "@/interfaces/services/feed";

const endpoint = {
  getFeed: "/feed/getFeed",
};

const getFeeds = async (data: GetFeedInterface) => {
  const { session } = data;

  const axiosConfig = {
    method: "GET",
    url: process.env.REACT_APP_BASE_URL + endpoint.getFeed,
    data: {
      session: session,
    },
    headers: {
      "content-type": "application/json",
      "Acess-Control-Allow-Origin": "*",
    },
  };

  return await axios
    .request(axiosConfig)
    .then((res) => {
      return {
        isError: false,
        data: res.data,
        error: "",
      };
    })
    .catch((err) => {
      return {
        isError: false,
        data: "",
        error: err,
      };
    });
};

export { getFeeds };
